import { DiagramDefinition } from "../types";

export const m023Definition: DiagramDefinition = {
  id: "M-023",
  title: "Solarch Tauri SDK Architecture",
  description:
    "Architectural diagram of Tauri integration showing the webview frontend with solarch/client connecting to Tauri Rust Core via IPC and directly to the Solarch BaaS instance over HTTP and WebSocket.",
  viewBox: "0 0 800 420",
  nodes: [
    // Tier 1: Frontend & Native Core
    {
      id: "TauriUI",
      kind: "client",
      label: "Tauri Webview Window",
      subtext: "React / Vite UI + solarch/client",
      position: [240, 60],
      size: [240, 50],
    },
    {
      id: "RustCore",
      kind: "service",
      label: "Tauri Rust Core",
      subtext: "Native Tray, Menus & Dialogs",
      position: [560, 60],
      size: [230, 50],
    },

    // Tier 2: IPC & Protocol Layer
    {
      id: "IPCBridge",
      kind: "service",
      label: "Tauri IPC Bridge",
      subtext: "invoke() / emit() / listen()",
      position: [400, 180],
      size: [220, 48],
    },

    // Tier 3: Solarch Backend & Storage
    {
      id: "SolarchInstance",
      kind: "database",
      label: "Solarch BaaS Engine",
      subtext: "Local Process / Cloud Instance",
      position: [240, 310],
      size: [240, 52],
    },
    {
      id: "StorageEngine",
      kind: "database",
      label: "SQLite WAL + Vector",
      subtext: "Auth, CRUD, Realtime & Files",
      position: [560, 310],
      size: [230, 52],
    },
  ],
  edges: [
    {
      id: "e1",
      source: "TauriUI",
      target: "RustCore",
      sourcePort: "right",
      targetPort: "left",
      label: "Native APIs",
      routing: "straight",
    },
    {
      id: "e2",
      source: "TauriUI",
      target: "IPCBridge",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "orthogonal",
    },
    {
      id: "e3",
      source: "RustCore",
      target: "IPCBridge",
      sourcePort: "bottom",
      targetPort: "top",
      routing: "orthogonal",
    },
    {
      id: "e4",
      source: "TauriUI",
      target: "SolarchInstance",
      sourcePort: "bottom",
      targetPort: "top",
      label: "HTTP & WS",
      animated: true,
      routing: "orthogonal",
    },
    {
      id: "e5",
      source: "SolarchInstance",
      target: "StorageEngine",
      sourcePort: "right",
      targetPort: "left",
      label: "SQL & Vector",
      routing: "straight",
      animated: true,
    },
  ],
};
